import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/ubicacion/importer/ubicacionImporterActions';

export default importerReducers(actions);
